import Css from "./style.module.scss";

import { FormElement } from "nlib/common/Form";
import FormContext from "contexts/FormContext";
import React, { useContext } from "react";
import SelectUncategorizedCategoryNames from "nlib/common/SelectUncategorizedCategoryNames";

const UncategorizedTransactions = (props) => {
  const { values: { uncategorizedCategoryNames } } = useContext(FormContext);

  return (
    <FormElement
      portal
      name="uncategorizedCategoryNames"
      readOnly={props.disabled}
      invalid={!uncategorizedCategoryNames?.length}
      className={Css.tagsInput}
      dropDownClassName={Css.uncategorizedDropDown}
      categories={props.classification}
      uncategorizedCategoryNames={props.uncategorizedCategoryNames}
      element={SelectUncategorizedCategoryNames} />
  );
};

export default UncategorizedTransactions;
